class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function(){
      $('.acc-trigger').click(function(){
        $(this).toggleClass('open');
        $(this).next('.acc-content').slideToggle();
      });
    });
  }
}
